package com.example.mystybag.login.views

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import org.w3c.dom.HTMLElement

@Composable
actual fun WelcomePageScrollLock() {
    DisposableEffect(Unit) {
        val html = document.documentElement as? HTMLElement
        val body = document.body as? HTMLElement

        val previousHtmlOverflow = html?.style?.getPropertyValue("overflow").orEmpty()
        val previousBodyOverflow = body?.style?.getPropertyValue("overflow").orEmpty()

        html?.style?.setProperty("overflow", "hidden")
        body?.style?.setProperty("overflow", "hidden")

        onDispose {
            html?.style?.setProperty("overflow", previousHtmlOverflow)
            body?.style?.setProperty("overflow", previousBodyOverflow)
        }
    }
}
